import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { CALL_SEND_INVITES, sendInvitesFailed, sendInvitesSuccess, SEND_INVITES_FAILED, SEND_INVITES_SUCCESS } from '../ducks/InvitesDucks';
import InvitesAPI from '../integrations/InvitesAPI';
import { showError } from '../ducks/ApplicationDucks';

function* sendInvites(action) {
  const { invites } = action;

  try {
    yield call(InvitesAPI.sendInvites, invites);
    yield put(sendInvitesSuccess());
  }
  catch(error) {
    yield put(
      sendInvitesFailed(
        error
        ? (error.errors && error.errors.length && error.errors[0].message)
        : 'Não foi possível enviar os convites'
      )
    );
  }
}

function* sendInvitesFailedSaga({ error }) {
  yield put(showError(error));
}

function sendInvitesSuccessSaga() {
  if (window.parent) {
    window.parent.postMessage({ type: SEND_INVITES_SUCCESS }, '*');
  }
}

function* sendInvitesSagas() {
  yield takeLatest(CALL_SEND_INVITES, sendInvites);
}

function* sendInvitesFailedSagas() {
  yield takeEvery(SEND_INVITES_FAILED, sendInvitesFailedSaga);
}

function* sendInvitesSuccessSagas() {
  yield takeEvery(SEND_INVITES_SUCCESS, sendInvitesSuccessSaga);
}

export default function* () {
  yield all([
    fork(sendInvitesSagas),
    fork(sendInvitesFailedSagas),
    fork(sendInvitesSuccessSagas)
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/InvitesSagas.js